// FIXME(CPP-0 isolated-api-client migration): scheduling-shared query-key
// factories are NOT part of its public API.
//
// The `@chilipiper/api-queries/src/meetings` and
// `@chilipiper/api-queries/src/user-availability` deep-subpath imports that
// chilical used pre-migration exposed each domain's `queryKeyFactory`. In the
// new isolated world `@chilipiper/scheduling-shared` re-exports ONLY the
// team-scheduling `queryKeyFactory` at its root — the meetings and
// user-availability factories stay internal (unlike `@chilipiper/integrations`,
// which DOES export its external-calendar factory as `externalCalendarQueryKeys`).
//
// chilical performs manual optimistic-cache updates keyed by those factories
// (src/api/meetings-platform.ts, src/pages/home/HomePage.tsx,
// src/api/user-availability.ts). Those keys MUST match the keys the
// scheduling-shared hooks write to, so the shapes below are copied verbatim
// from scheduling-shared @ 1.1897.0:
//   frontend-packages/scheduling-shared/src/api-queries/meetings.ts
//   frontend-packages/scheduling-shared/src/api-queries/user-availability.ts
//
// This shim is a temporary compile-and-behavior bridge. The durable fix is for
// scheduling-shared to export these factories (mirroring integrations); until
// then this file must be kept byte-identical to the upstream key shapes.

// --- meetings (from scheduling-shared/src/api-queries/meetings.ts) ---
export type FilterParams = {
  end?: string
  sort?: string
  start?: string
  search?: string
  userIds?: string[]
}

const meetingsQueryKey = 'meetings'

export const meetingsQueryKeyFactory = {
  listMeetings: (params: FilterParams) => [
    meetingsQueryKey,
    'filter',
    params.start,
    params.end,
    params.search,
    params.sort,
    params.userIds,
  ],
  getMeeting: (meetingId: string) => [meetingsQueryKey, 'meetingId', meetingId],
  listMeetingsByFilter: (filter: Record<string, unknown>) => [
    meetingsQueryKey,
    'meetings-activity',
    'table',
    filter,
  ],
}

// --- user-availability (from scheduling-shared/src/api-queries/user-availability.ts) ---
const prioritySettingsQueryKey = 'user-priority-settings'
const seriesSettingQueryKey = 'series-setting'
const seriesSettingsQueryKey = 'series-settings'

export const userAvailabilityQueryKeyFactory = {
  prioritySettings: (ids: unknown[]) => [prioritySettingsQueryKey, ids],
  seriesSetting: (seriesId: string) => [seriesSettingQueryKey, seriesId],
  seriesSettings: (seriesIds: string[]) => [seriesSettingsQueryKey, seriesIds],
}
